import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ufufbh5wqc: FaireBrandEntity = {
  token: "b_ufufbh5wqc",
  type: "brand",
  name: "Orice",
  avatarUrl:
    "https://cdn.faire.com/fastly/6f48484ffebc7f63163f1c83aa171f1168003196a5c72df106d63fb7cebc74a7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/89e7b2da939184906e3b03c50151d4ca1de3cb1beab873a59501d1664ac7f8c2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6f48484ffebc7f63163f1c83aa171f1168003196a5c72df106d63fb7cebc74a7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/89e7b2da939184906e3b03c50151d4ca1de3cb1beab873a59501d1664ac7f8c2.jpeg",
  location: "Paris , FRA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 45,
  isTopShop: true,
  isInsider: false,
  description:
    "Orice was born out of the desire to offer a versatile women's wardrobe. Locked in the monotony of daily life, we were aware that something essential for women was missing: comfort and freedom. That's how Orice was born. Our aim was to create a unique fashion experience, offering women the opportunity to feel comfortable while expressing their personality through their clothing style. Orice has become an iconic brand that embodies freedom and romance, offering clothing that is both comfortable and stylish for modern women who want to stand out from the crowd.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:51.008Z",
    importedBy: "entity-db-cli",
  },
};
